// Sprint monitor-tool-live-timer — format an elapsed-ms value as the
// "Waiting Xs / Xm Ys / Xh Ym" string Cursor shows for long-running
// background tasks.
//
// The output goes through i18n so the Spanish locale reads "Esperando".
// Always rounds down to whole seconds; negative inputs clamp to 0 (a
// startedAtMs slightly in the future during clock drift should never
// render a negative timer).

import type { TKey } from '../../i18n';

type Translator = (key: TKey, params?: Record<string, string | number>) => string;

export function formatElapsed(elapsedMs: number, t: Translator): string {
  const totalSec = Math.max(0, Math.floor(elapsedMs / 1000));
  if (totalSec < 60) return t('toolCall.waitingSeconds', { s: totalSec });
  if (totalSec < 3600) {
    const m = Math.floor(totalSec / 60);
    const s = totalSec % 60;
    return t('toolCall.waitingMinutes', { m, s });
  }
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  return t('toolCall.waitingHours', { h, m });
}
